import { TFunction } from '@lyearn/i18n';
import { ExerciseQuestionInput } from '@/types/schema';

const validateLikert = (t: TFunction, question?: ExerciseQuestionInput) => {
  if (!question?.customRatingComponent) {
    return;
  }

  if (
    !question.customRatingComponent.ratingLabels?.length ||
    question.customRatingComponent.ratingLabels.some((label) => !label.labelName?.trim())
  ) {
    return {
      message: t('Exercise:Creator.LikertLabelsRequired'),
    };
  }
};

export default validateLikert;
